<p-table
  #pt
  [value]="audits"
  [paginator]="true"
  [rows]="50"
  [rowsPerPageOptions]="[50,250,500,1000]"
  paginatorDropdownAppendTo="body"
  showCurrentPageReport="true"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} changes"
  sortMode="multiple"
  selectionMode="single"
  [(selection)]="audit"
  dataKey="id"
  (onRowSelect)="onRowSelect($event)"
  [loading]="loading"
  [globalFilterFields]="['id','date','property','left','right','author','objectId']"
  styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines audit-table">

  <ng-template pTemplate="caption">
    <div class="d-flex align-items-center gap-2">
      <i class="pi pi-search" style="margin:4px 4px 0 0;"></i>
      <input type="text" pInputText placeholder="Filter changes..."
        (input)="pt.filterGlobal($event.target.value, 'contains')" style="width:200px;">
      <span class="audit-count">{{audits.length}} total changes</span>
      <span class="ms-auto">
        <button pButton pRipple class="p-button-text p-button-sm"
          (click)="reloadPage()">Clear Filters</button>
      </span>
    </div>
  </ng-template>

  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="id" class="col-id">Id <p-sortIcon field="id"></p-sortIcon></th>
      <th pSortableColumn="date" class="col-date">Date <p-sortIcon field="date"></p-sortIcon></th>
      <th pSortableColumn="author" class="col-author">Changed By <p-sortIcon field="author"></p-sortIcon></th>
      <th pSortableColumn="property" class="col-field">Field <p-sortIcon field="property"></p-sortIcon></th>
      <th pSortableColumn="left" class="col-old">Old <p-sortIcon field="left"></p-sortIcon></th>
      <th pSortableColumn="right" class="col-new">New <p-sortIcon field="right"></p-sortIcon></th>
      <th pSortableColumn="objectId" class="col-objid">Object Id <p-sortIcon field="objectId"></p-sortIcon></th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-audit>
    <tr>
      <td class="col-id text-muted">{{audit.id}}</td>
      <td class="col-date" style="white-space:nowrap">{{audit.date | date:'MM/dd/yy h:mma':'PST'}}</td>
      <td class="col-author">{{audit.author}}</td>
      <td class="col-field fw-semibold">{{audit.property}}</td>
      <td class="col-old" [ngClass]="audit.left != null ? 'old-value' : 'no-value'" [pTooltip]="audit.left?.toString()" tooltipPosition="top">{{audit.left != null ? audit.left : '-- Blank --'}}</td>
      <td class="col-new" [ngClass]="audit.right != null ? 'new-value' : 'no-value'" [pTooltip]="audit.right?.toString()" tooltipPosition="top">{{audit.right != null ? audit.right : '-- Blank --'}}</td>
      <td class="col-objid text-muted">{{audit.objectId}}</td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="7" class="text-center p-4 text-muted">No change history found.</td>
    </tr>
  </ng-template>

</p-table>
